import store from '@/config/vuex'
import { BrowserAgent } from '@newrelic/browser-agent'

const options = {
  info: {
    applicationID: process.env.NEWRELIC_APPLICATION_ID,
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: '030b718d64',
    sa: 1,
  },
  init: {
    ajax: {
      deny_list: ['bam.nr-data.net'],
    },
    distributed_tracing: {
      allowed_origins: ['https://www.on.com', 'https://www-staging.on.com'],
      cors_use_newrelic_header: false,
      cors_use_tracecontext_headers: true,
      enabled: true,
    },
    privacy: {
      cookies_enabled: true,
    },
  },
  loader_config: {
    accountID: '1471050',
    agentID: process.env.NEWRELIC_AGENT_ID,
    applicationID: process.env.NEWRELIC_APPLICATION_ID,
    licenseKey: '030b718d64',
    trustKey: '1471050',
  },
}

async function initializeNewRelic() {
  try {
    new BrowserAgent(options)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to initialize New Relic:', error)
  }
}

export function checkConsentAndInitialize() {
  const hasPerformanceConsent = store.getters['cookieConsent/isCookiePerformanceAccepted']

  if (hasPerformanceConsent) {
    initializeNewRelic()
  }
}
